/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './payment-scheme.reducer';

export const PaymentSchemeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paymentSchemeEntity = useAppSelector(state => state.paymentScheme.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paymentSchemeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paymentScheme.detail.title">PaymentScheme</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.id">Id</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.name">Name</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.name}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.endDate}</dd>
          <dt>
            <span id="addedBy">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.addedBy">Added By</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.addedBy}</dd>
          <dt>
            <span id="maxDiscountPercentage">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.maxDiscountPercentage">Max Discount Percentage</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.maxDiscountPercentage}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="suspendedReason">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.suspendedReason">Suspended Reason</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.suspendedReason}</dd>
          <dt>
            <span id="suspendedDate">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.suspendedDate">Suspended Date</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.suspendedDate}</dd>
          <dt>
            <span id="suspendedBy">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.suspendedBy">Suspended By</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.suspendedBy}</dd>
          <dt>
            <span id="packageType">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.packageType">Package Type</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.packageType}</dd>
          <dt>
            <span id="serviceType">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.serviceType">Service Type</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.serviceType}</dd>
          <dt>
            <span id="gracePeriod">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.gracePeriod">Grace Period</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.gracePeriod}</dd>
          <dt>
            <span id="remindBefore">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.remindBefore">Remind Before</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.remindBefore}</dd>
          <dt>
            <span id="proposedValue">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.proposedValue">Proposed Value</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.proposedValue}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.active">Active</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.timestampEntry}</dd>
          <dt>
            <span id="pharmacyDiscPercent">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.pharmacyDiscPercent">Pharmacy Disc Percent</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.pharmacyDiscPercent}</dd>
          <dt>
            <span id="maxDiscountAmount">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.maxDiscountAmount">Max Discount Amount</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.maxDiscountAmount}</dd>
          <dt>
            <span id="maxCapAmount">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.maxCapAmount">Max Cap Amount</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.maxCapAmount}</dd>
          <dt>
            <span id="discPreference">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.discPreference">Disc Preference</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.discPreference}</dd>
          <dt>
            <span id="enforceCap">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.enforceCap">Enforce Cap</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.enforceCap ? 'true' : 'false'}</dd>
          <dt>
            <span id="extendedTarrifs">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.extendedTarrifs">Extended Tarrifs</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.extendedTarrifs ? 'true' : 'false'}</dd>
          <dt>
            <span id="labDiscPercent">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.labDiscPercent">Lab Disc Percent</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.labDiscPercent}</dd>
          <dt>
            <span id="consDiscPercent">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.consDiscPercent">Cons Disc Percent</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.consDiscPercent}</dd>
          <dt>
            <span id="procedureDiscPercent">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.procedureDiscPercent">Procedure Disc Percent</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.procedureDiscPercent}</dd>
          <dt>
            <span id="ipDiscPercent">
              <Translate contentKey="tinyMedicRestApp.paymentScheme.ipDiscPercent">Ip Disc Percent</Translate>
            </span>
          </dt>
          <dd>{paymentSchemeEntity.ipDiscPercent}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paymentScheme.hospital">Hospital</Translate>
          </dt>
          <dd>{paymentSchemeEntity.hospital ? paymentSchemeEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paymentScheme.institution">Institution</Translate>
          </dt>
          <dd>{paymentSchemeEntity.institution ? paymentSchemeEntity.institution.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/payment-scheme" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/payment-scheme/${paymentSchemeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PaymentSchemeDetail;
